import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function BookNowButton({ id }) {
  const navigate = useNavigate();
  const { cartData } = useSelector((state) => state?.parsistStates);

  const handleBookPackage = (event) => {
    event.stopPropagation();
    navigate(`/booking?id=${btoa(id)}`);
  };

  const isValid =
    cartData?.length > 0 &&
    cartData[0]?.package?.some((e) => e.package_id === id);

  return (
    <button
      disabled={isValid}
      onClick={(event) => !isValid && handleBookPackage(event)}
      className="btn btn-md"
    >
      <span>{isValid ? "Added In Cart" : "Book Now"}</span>
    </button>
    
  );
}

export default BookNowButton;
